import { useCallback, useEffect, useState } from 'react';
import { InboxChat } from 'types/user';
import { createInboxChat, getFilesChat, hiddenInboxChat } from 'services/files';
import { unionBy } from 'lodash';
const size = 50;
export const useMessagePage = () => {
  const [notes, setNotes] = useState<{
    rows: InboxChat[];
    page: number;
    hasMore: boolean;
  }>({
    rows: [],
    page: 1,
    hasMore: false
  });

  const handleGetDetailChat = useCallback(async (page = 1) => {
    const params = {
      page,
      size
    };
    const data = await getFilesChat(params);
    setNotes((prev) => {
      const rows = unionBy(prev.rows, data?.notes, 'id').sort(
        (a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()
      );
      return {
        rows: rows,
        page: rows.length % size === 0 ? page + 1 : page,
        hasMore: rows.length % size === 0 ? (data?.total || 0) > size * page : false
      };
    });
  }, []);

  const fetchMoreChatDetail = useCallback(async () => {
    if (!notes) return;
    await handleGetDetailChat(notes.page);
  }, [notes, handleGetDetailChat]);

  useEffect(() => {
    handleGetDetailChat();
    const interval = setInterval(() => {
      handleGetDetailChat();
    }, 6000);

    return () => clearInterval(interval);
  }, []);

  const handleCreateMessage = useCallback(
    async (content: string, fileId: number) => {
      await createInboxChat(content, Number(fileId));
      await handleGetDetailChat(1);
    },
    [handleGetDetailChat]
  );
  const handleDeleteMessage = useCallback(async (idChat: number) => {
    if (!idChat) return;
    const confirmDelete = window.confirm('Are you sure you want to delete this message?');
    if (!confirmDelete) return;
    setNotes((pre) => ({ ...pre, rows: pre.rows.filter((item) => Number(item.id) !== idChat) }));
    await hiddenInboxChat(idChat);
  }, []);

  return {
    fetchMoreChatDetail,
    handleDeleteMessage,
    onSendMessage: handleCreateMessage,
    messageNotes: notes.rows,
    hasMoreMessage: notes.hasMore
  };
};
